import styled from 'styled-components';

export const PresetGrid = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const SelectAllControl = styled.label`
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: 12px;
	color: ${({ theme }) => theme.gray[1000]};

	input {
		margin: 0;
	}
`;

export const CountText = styled.span`
	color: ${({ theme }) => theme.gray[600]};
`;

export const ScopeList = styled.div`
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	max-height: 220px;
	overflow-y: auto;
`;

export const ScopeRow = styled.label<{ $isSelected?: boolean }>`
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 8px 10px;
	border-radius: 6px;
	font-size: 13px;
	color: ${({ theme }) => theme.gray[1000]};
	background: ${({ theme, $isSelected }) =>
		$isSelected ? `${theme.blue[500]}0F` : 'transparent'};
	transition: background-color 0.15s ease;

	&:hover {
		background: ${({ theme, $isSelected }) =>
			$isSelected ? `${theme.blue[500]}1A` : theme.gray[100]};
	}
`;

export const ScopeRowInput = styled.input`
	margin: 0;
`;

export const EmptyNote = styled.div`
	font-size: 12px;
	color: ${({ theme }) => theme.gray[600]};
	padding: 6px 0;
`;

export const PromptTextarea = styled.textarea`
	box-sizing: border-box;
	width: 100%;
	min-height: 120px;
	padding: 10px 12px;
	font-family: inherit;
	font-size: 13px;
	line-height: 1.4;
	color: ${({ theme }) => theme.gray[1000]};
	background: ${({ theme }) => theme.gray[0]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 8px;
	resize: vertical;
	outline: none;

	&:focus {
		border-color: ${({ theme }) => theme.blue[500]};
	}

	&::placeholder {
		color: ${({ theme }) => theme.gray[600]};
	}
`;
